import { Component, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [RouterLink, FormsModule],
  templateUrl: './landing.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './landing.component.scss'
})
export class LandingComponent {

  // Menu a panino: sotto i 700px i link stanno in un pannello che si apre
  // sotto la barra. Sopra quella soglia la classe non ha alcun effetto.
  menuOpen = false;

  // Scorrendo, la barra sale a filo del bordo (top 0): lo spazio che lasciava
  // sopra di sé mostrava il contenuto che passava.
  scrolled = false;

  @HostListener('window:scroll')
  onScroll(): void {
    this.scrolled = window.scrollY > 8;
  }

  /**
   * Le tessere dell'arcade. Stanno qui e non nel template perché sono sette e
   * cresceranno: aggiungere un gioco è una riga, e la logica dell'anteprima
   * animata resta scritta una volta sola.
   *
   * `animata` dice che il gioco ha la sua `thumb-hover.webp` — la miniatura in
   * movimento che si genera con `npm run bananai:thumb-hover`. Oggi ce l'hanno
   * tutti, ma il campo resta: un gioco nuovo entra in griglia prima che la sua
   * animazione esista, e con `animata: false` tiene l'emoji e si comporta come
   * prima invece di chiedere al server un file che non c'è.
   */
  readonly giochi = [
    { id: 'gemburst',   emoji: '💎', nome: 'Gem Burst',  genere: 'Match-3 · gemme speciali', animata: true  },
    { id: 'meteorites', emoji: '🚀', nome: 'Meteorites', genere: 'Shooter spaziale',         animata: true  },
    { id: 'alien-fall', emoji: '👾', nome: 'Alien Fall', genere: 'Difendi la Terra',         animata: true  },
    { id: 'malaga',     emoji: '🛸', nome: 'Malaga',     genere: 'Ondate aliene',            animata: true  },
    { id: 'squash',     emoji: '🧱', nome: 'Squash',     genere: 'Spacca i mattoni',         animata: true  },
    { id: 'trekking',   emoji: '🥾', nome: 'Trekking',   genere: 'Platform di montagna',     animata: true  },
    { id: 'miaojong',   emoji: '🐱', nome: 'Miaojong',   genere: 'Mahjong solitario',        animata: true  },
  ];

  /**
   * I giochi la cui anteprima è già stata chiesta al server.
   *
   * L'immagine non sta nel template dall'inizio: sono ~190 KB l'una, e sette
   * anteprime scaricate da chi la home la scorre e basta sono più peso di
   * tutto il resto della pagina. Entra nel DOM al primo passaggio del mouse e
   * poi ci resta — nascosta dal CSS — così dal secondo passaggio parte subito.
   *
   * Da qui non passa il telefono: l'animazione la mostra `:hover`, e senza
   * puntatore quel passaggio non avviene mai. È la stessa scelta del portale,
   * che sotto il dito lascia sempre la miniatura ferma.
   */
  readonly anteprime = new Set<string>();

  showContact    = false;
  contactName    = '';
  contactPhone   = '';
  contactMsg     = '';
  contactSending = false;
  contactStatus: 'idle' | 'ok' | 'error' = 'idle';

  private contactOpenedAt = Math.floor(Date.now() / 1000);

  constructor(private http: HttpClient) {}

  openContact(): void {
    this.showContact    = !this.showContact;
    this.contactOpenedAt = Math.floor(Date.now() / 1000);
  }

  sendContact(e: Event): void {
    e.preventDefault();
    if (!this.contactName.trim() || !this.contactMsg.trim() || this.contactSending) return;

    this.contactSending = true;
    this.contactStatus  = 'idle';

    this.http.post<{ ok: boolean }>('/php/api/contact.api.php', {
      name:    this.contactName.trim(),
      phone:   this.contactPhone.trim(),
      message: this.contactMsg.trim(),
      website: '',
      _t:      this.contactOpenedAt,
    }).subscribe({
      next: () => {
        this.contactStatus   = 'ok';
        this.contactSending  = false;
        this.contactName     = '';
        this.contactPhone    = '';
        this.contactMsg      = '';
        this.contactOpenedAt = Math.floor(Date.now() / 1000);
      },
      error: () => {
        this.contactStatus  = 'error';
        this.contactSending = false;
      }
    });
  }
}
